export const APP_TITLE = import.meta.env.VITE_APP_TITLE;
